import { useEffect, useRef, useState } from "react";

import { cx } from "@/utils";

import styles from "./EditableField.module.css";
// based on https://github.com/learnwithparam/logrocket-inline-edit-ui/blob/master/src/Editable.js

const Editable = ({
  text,
  type,
  inputRef,
  placeholder,
  children,
  childRef,
  ...props
}) => {
  const [isEditing, setEditing] = useState(false);

  useEffect(() => {
    if (childRef && childRef.current && isEditing === true) {
      childRef.current.focus();
    }
  }, [isEditing, childRef]);

  const handleKeyDown = (event, type) => {
    const { key } = event;
    const keys = ["Escape", "Tab"];
    const enterKey = "Enter";
    const allKeys = [...keys, enterKey];

    if (
      (type === "textarea" && keys.indexOf(key) > -1) ||
      (type !== "textarea" && allKeys.indexOf(key) > -1)
    ) {
      setEditing(false);
      props.onBlur?.(event);
    }
  };

  return (
    <section {...props}>
      {isEditing ? (
        <div
          ref={inputRef}
          onBlur={() => setEditing(false)}
          onKeyDown={(e) => handleKeyDown(e, type)}
        >
          {children}
        </div>
      ) : (
        <button
          className={cx(styles.title, props.className)}
          onClick={() => setEditing(true)}
        >
          <span>
            {text || placeholder || L.REPORTS_REPORT_TITLE_PLACEHOLDER}
          </span>
        </button>
      )}
    </section>
  );
};

const EditableField = ({ className, disabled, ...rest }) => {
  const inputRef = useRef();

  return (
    <Editable
      text={rest.value}
      type="text"
      placeholder={rest.placeholder}
      className={cx(styles.root, className)}
      childRef={inputRef}
      onBlur={rest.onBlur}
      data-testid="report-title"
      disabled={disabled}
    >
      <input
        disabled={disabled}
        type="text"
        className={`form-control ${styles.input}`}
        ref={inputRef}
        maxLength={255}
        onFocus={(e) => {
          if (rest.placeholder === e.target.value) {
            e.target.select();
          }
        }}
        {...rest}
        data-testid="report-title-input"
      />
    </Editable>
  );
};

export { EditableField };
